function IsUserNotValidRedirections() {

	var check_url = 'my-account';
	var has_subscription = window.UserProfile.has_subscription;
	var is_page_correct = '';
	var user_has_access = '';


	// Check if Correct Page
	if( window.location.pathname.includes('/' + check_url + '/') || window.location.pathname.includes('/' + check_url) ) {
		is_page_correct = true;
	}

	// Check if User Have Access
	if( has_subscription == undefined || has_subscription == false ) {
		user_has_access = false;
	} 

	if( is_page_correct === true && user_has_access ===  false ) {
		// Redirection
		window.location.href = window.location.origin;
        
		// Dispatch Event
		const nosubscription = new CustomEvent( "nosubscription" );
		document.dispatchEvent( nosubscription );
		const api_error = new CustomEvent( "apierror" );
		document.dispatchEvent( api_error );
	}
}

export { IsUserNotValidRedirections };
